import { api, parseApiError } from './api';
import type {
  ReceiptWithTransactions,
  ReceiptListResponse,
  ReceiptFilters,
} from '@/types/receipt';

export const receiptsService = {
  /**
   * Get paginated list of receipts for the authenticated user
   */
  async getReceipts(filters: ReceiptFilters = {}): Promise<ReceiptListResponse> {
    try {
      const params: Record<string, string | number> = {};

      if (filters.limit) params.limit = filters.limit;
      if (filters.offset) params.offset = filters.offset;
      if (filters.year) params.year = filters.year;
      if (filters.status) params.status = filters.status;

      const response = await api.get<ReceiptListResponse>('/api/receipts', { params });
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Get a single receipt by ID with associated transactions
   */
  async getReceipt(id: string): Promise<ReceiptWithTransactions> {
    try {
      const response = await api.get<ReceiptWithTransactions>(`/api/receipts/${id}`);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default receiptsService;
